export default __webpack_public_path__ + "locales/si/Translations.json?hash=92d4bc3d912d0ce14774fb596e35bd03";